import React, { useContext } from "react";
import { ArrowBackRounded, LinkOffRounded } from "@mui/icons-material";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { AppVarsContext } from "../../context/AppVarsContext";
import GlassPageShell from "../../components/glass/GlassPageShell";
import GlassPanel from "../../components/glass/GlassPanel";

const NotFound = () => {
  const location = useLocation();
  const { appAppearance } = useContext(AppVarsContext);

  return (
    <GlassPageShell
      eyebrow="404 Error"
      title="Page Not Found"
      description="The page you requested could not be found."
      badge="404"
      maxWidth={1100}
    >
      <GlassPanel
        sx={{
          p: { xs: 3, md: 4.5 },
          textAlign: "center",
          background: `linear-gradient(150deg, ${alpha("#ffffff", 0.82)} 0%, ${alpha(appAppearance.colors.secondary, 0.08)} 100%)`,
        }}
      >
        <Stack spacing={2.5} alignItems="center">
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: alpha(appAppearance.colors.primary, 0.1),
              border: `1px solid ${appAppearance.colors.border}`,
              color: appAppearance.colors.primary,
            }}
          >
            <LinkOffRounded />
          </Box>

          <Box>
            <Typography
              variant="overline"
              sx={{
                color: appAppearance.colors.textMuted,
                letterSpacing: "0.16em",
                fontWeight: 700,
              }}
            >
              Not Found
            </Typography>
            <Typography
              variant="h3"
              sx={{
                mt: 0.5,
                color: appAppearance.colors.textPrimary,
                fontWeight: 800,
                letterSpacing: "-0.04em",
              }}
            >
              The requested platform view could not be found.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mt: 1.25,
                maxWidth: 640,
                color: appAppearance.colors.textSecondary,
                lineHeight: 1.7,
              }}
            >
              Check the link or go back to continue.
            </Typography>
          </Box>

          <Chip
            label={location.pathname}
            sx={{
              maxWidth: "100%",
              borderRadius: "999px",
              bgcolor: alpha("#ffffff", 0.6),
              border: `1px solid ${appAppearance.colors.border}`,
              "& .MuiChip-label": {
                px: 1.5,
                fontWeight: 700,
                color: appAppearance.colors.textPrimary,
                textOverflow: "ellipsis",
                overflow: "hidden",
              },
            }}
          />

          <Button
            onClick={() => window.history.back()}
            endIcon={<ArrowBackRounded />}
            sx={{
              borderRadius: "999px",
              px: 2,
              py: 1,
              textTransform: "none",
              fontWeight: 700,
              boxShadow: "none",
              color: "#ffffff",
              background: `linear-gradient(135deg, ${appAppearance.colors.primary} 0%, ${appAppearance.colors.secondary} 100%)`,
              "&:hover": {
                boxShadow: appAppearance.shadows.raised,
                background: `linear-gradient(135deg, ${appAppearance.colors.primary} 0%, ${appAppearance.colors.secondary} 100%)`,
              },
            }}
          >
            Go Back
          </Button>
        </Stack>
      </GlassPanel>
    </GlassPageShell>
  );
};

export default NotFound;
